import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Admin from './pages/Admin'; // Import the new Admin component
import AboutUs from './pages/AboutUs';
import YouTubeTestPage from './pages/YouTubeTestPage';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="min-h-screen bg-navy-black text-light">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services/:id" element={<Services />} />
          <Route path="/admin" element={<Admin />} /> {/* Add the admin route */}
          <Route path="/youtube-test" element={<YouTubeTestPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;